import { defineMessage } from "react-intl";

export const INVOICES_SORT_VALUE_CREATED_ASC = "created_asc";
export const INVOICES_SORT_VALUE_CREATED_DESC = "created_desc";
export const INVOICES_SORT_VALUE_INVOICE_DATE_ASC = "invoice_date_asc";
export const INVOICES_SORT_VALUE_INVOICE_DATE_DESC = "invoice_date_desc";

export const INVOICES_SORTS = {
  [INVOICES_SORT_VALUE_CREATED_ASC]: {
    id: INVOICES_SORT_VALUE_CREATED_ASC,
    label: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [INVOICES_SORT_VALUE_CREATED_DESC]: {
    id: INVOICES_SORT_VALUE_CREATED_DESC,
    label: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
  [INVOICES_SORT_VALUE_INVOICE_DATE_ASC]: {
    id: INVOICES_SORT_VALUE_INVOICE_DATE_ASC,
    label: defineMessage({ defaultMessage: "Date de facture croissante" }),
  },
  [INVOICES_SORT_VALUE_INVOICE_DATE_DESC]: {
    id: INVOICES_SORT_VALUE_INVOICE_DATE_DESC,
    label: defineMessage({ defaultMessage: "Date de facture décroissante" }),
  },
};

export const INVOICES_SORTS_LIST = Object.values(INVOICES_SORTS);

// ============================================================================

export const INVOICES_STATES_VALUE_EMITTED = "emitted";
export const INVOICES_STATES_VALUE_CANCELLED = "cancelled";
export const INVOICES_STATES_VALUE_QUOTED = "quoted";

export const INVOICES_STATES = {
  [INVOICES_STATES_VALUE_EMITTED]: {
    value: INVOICES_STATES_VALUE_EMITTED,
    label: defineMessage({ defaultMessage: "Émise" }),
    labelPlural: defineMessage({ defaultMessage: "Émises" }),
    colors: ["green.600", "green.300"],
    displayedInSearch: true,
  },
  [INVOICES_STATES_VALUE_CANCELLED]: {
    value: INVOICES_STATES_VALUE_CANCELLED,
    label: defineMessage({ defaultMessage: "Annulée" }),
    labelPlural: defineMessage({ defaultMessage: "Annulées" }),
    colors: ["orange.600", "orange.300"],
    displayedInSearch: true,
  },
  [INVOICES_STATES_VALUE_QUOTED]: {
    value: INVOICES_STATES_VALUE_QUOTED,
    label: defineMessage({ defaultMessage: "Devis" }),
    labelPlural: defineMessage({ defaultMessage: "Devis" }),
    colors: ["gray.600", "gray.300"],
    displayedInSearch: false,
  },
};

export const INVOICES_STATES_LIST = Object.values(INVOICES_STATES);

// ============================================================================

export const INVOICES_TYPES_VALUE_INVOICE = "invoice";
export const INVOICES_TYPES_VALUE_CREDIT_NOTE = "credit_note";

export const INVOICES_TYPES = {
  [INVOICES_TYPES_VALUE_INVOICE]: {
    value: INVOICES_TYPES_VALUE_INVOICE,
    label: defineMessage({ defaultMessage: "Facture" }),
    displayedInSearch: true,
  },
  [INVOICES_TYPES_VALUE_CREDIT_NOTE]: {
    value: INVOICES_TYPES_VALUE_CREDIT_NOTE,
    label: defineMessage({ defaultMessage: "Facture d'avoir" }),
    displayedInSearch: true,
  },
};

export const INVOICES_TYPES_LIST = Object.values(INVOICES_TYPES);

// ============================================================================

export const INVOICES_CUSTOMER_TYPES_VALUE_CUSTOMER = "customer";
export const INVOICES_CUSTOMER_TYPES_VALUE_ENVIRONMENT = "environment";

export const INVOICES_CUSTOMER_TYPES = {
  [INVOICES_CUSTOMER_TYPES_VALUE_CUSTOMER]: {
    value: INVOICES_CUSTOMER_TYPES_VALUE_CUSTOMER,
    label: defineMessage({ defaultMessage: "Client" }),
    displayedInSearch: true,
  },
  [INVOICES_CUSTOMER_TYPES_VALUE_ENVIRONMENT]: {
    value: INVOICES_CUSTOMER_TYPES_VALUE_ENVIRONMENT,
    label: defineMessage({ defaultMessage: "Environnement" }),
    displayedInSearch: true,
  },
};

export const INVOICES_CUSTOMER_TYPES_LIST = Object.values(
  INVOICES_CUSTOMER_TYPES,
);

// ============================================================================

export const INVOICES_FACTURATION_MODES_VALUE_PRESENT = "present";
export const INVOICES_FACTURATION_MODES_VALUE_ABSENT = "absent";
export const INVOICES_FACTURATION_MODES_VALUE_MISSING = "missing";

export const INVOICES_FACTURATION_MODES = {
  [INVOICES_FACTURATION_MODES_VALUE_PRESENT]: {
    value: INVOICES_FACTURATION_MODES_VALUE_PRESENT,
    label: defineMessage({ defaultMessage: "Présent" }),
    description: defineMessage({
      defaultMessage: "Facturer si l'adhérent est présent.",
    }),
    displayedInSearch: true,
  },
  [INVOICES_FACTURATION_MODES_VALUE_ABSENT]: {
    value: INVOICES_FACTURATION_MODES_VALUE_ABSENT,
    label: defineMessage({ defaultMessage: "Absent" }),
    description: defineMessage({
      defaultMessage: "Facturer si l'adhérent est absent.",
    }),
    displayedInSearch: true,
  },
  [INVOICES_FACTURATION_MODES_VALUE_MISSING]: {
    value: INVOICES_FACTURATION_MODES_VALUE_MISSING,
    label: defineMessage({ defaultMessage: "Manquant" }),
    description: defineMessage({
      defaultMessage: "Facturer si l'adhérent n'a pas été pointé.",
    }),
    displayedInSearch: true,
  },
};

export const INVOICES_FACTURATION_MODES_LIST = Object.values(
  INVOICES_FACTURATION_MODES,
);

// ============================================================================
